import { resolveEndpoint } from '../../resolveEndpoint';
import { IEndpoint } from '../../types';

import { parsePlayerConfigResponseJSON, parsePlayerConfigResponseXML } from './parsers';
import { IPlayerConfigResponseJSON, IPlayerConfigResponseXML, PlayerConfigType, PlayerConfigVersion } from './types';

export const playerConfigEndpoint: IEndpoint<PlayerConfigType, { operatorGameId?: string }> = resolveEndpoint(
  'playerConfig',
  {
    [PlayerConfigVersion.JSP]: {
      url: '/cgibin/playerconfig.jsp',
      parser: (rawResponse, options): PlayerConfigType =>
        parsePlayerConfigResponseXML(rawResponse as IPlayerConfigResponseXML, options.operatorGameId),
      format: 'xml',
      root: 'response',
    },
    [PlayerConfigVersion.PREFERENCES]: {
      url: '/api/config/preferences',
      parser: (rawResponse, options): PlayerConfigType =>
        parsePlayerConfigResponseJSON(rawResponse as IPlayerConfigResponseJSON, options),
      format: 'json',
    },
  }
);
